import React, { FC, ReactElement, useMemo } from 'react';
import {
    PromoSelectionItem,
    PromoSelection as PromoSelectionModel,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { createSignal } from '@funtech-int/rival';
import { useSignal } from '@funtech-int/rival-react';

import { Fader } from '../Fader/Fader';

import styles from './_PromoSelection.module.css';

interface RenderItemProps {
    item: PromoSelectionItem;
    index: number;
    next: () => void;
}

interface PromoBlockProps {
    selection: PromoSelectionModel;
    supports: PromoSelectionItem['type'][];
    renderItem?(props: RenderItemProps): ReactElement;
}

export const PromoSelection: FC<PromoBlockProps> = ({ selection, supports, renderItem }) => {
    const contoller = useMemo(() => {
        const items = selection.items.filter((item) => supports.includes(item.type));
        const currentPosition = createSignal(0);

        return {
            items,
            currentPosition: currentPosition.seal(),
            goToNext() {
                currentPosition.set((currentPosition.get() + 1) % items.length);
            },
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selection.items]);

    const currentPosition = useSignal(contoller.currentPosition);
    const item = contoller.items[currentPosition] as PromoSelectionItem;

    return (
        <div className={styles.root}>
            <Fader contentKey={currentPosition}>
                {renderItem?.({
                    index: currentPosition,
                    item,
                    next: contoller.goToNext,
                })}
            </Fader>
        </div>
    );
};
